import Fetch from "@src/API/Fetch.js"
import Format from "@src/utils/Format.js"

export default async function Load(id) {
  let result;

  if(id){
    let response = await fetch(`/preset/${id}.json`, {
      method: "GET"
    });

    if(response.ok) {
      result = await response.json();
    } else {
      throw 'Failed'
    }
  } else {
    result = await Fetch("GET", `node/${id}`)
  }
  
  return await Format("tree", result);
}
